module.exports = __webpack_public_path__ + "img/stock6.53a8ef27.png";